import { render, staticRenderFns } from "./ActSuccess.vue?vue&type=template&id=05a1fbae&"
import script from "./ActSuccess.vue?vue&type=script&lang=js&"
export * from "./ActSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports